import { globalPrompt } from "@/components/message";
import useGlobalModel, { transPgToPagination } from "@/model/globalModel";
import { ISearchPage } from "@/types/ScmTypes";
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from "@/utils/constants";
import { convertRes2Blob } from "@/utils/exportFile";
import { TablePaginationConfig } from "antd/lib/table";
import { createModel } from "hox";
import { useState } from "react";
import { supplierService } from "./supplierService";
import { ISupplierDetail, ISupplierSearchFields } from "./supplierTypes";

export const useSupplierModel = createModel(function () {
    const {setLoadingInfo } = useGlobalModel();
    const initSearch = { }
    //查询条件
    const [searchParam, setSearchParam] = useState<ISupplierSearchFields>(initSearch);
    //列表数据源
    const [dataSource, setDataSource] = useState<ISupplierDetail[]>([]);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //列表数据源分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const [loading, setLoading] = useState<boolean>(false);

    const updateSearchParam = (updateParam: ISupplierSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }


    //重置
    const resetSearchParam = () => {
        setSearchParam(initSearch);
        setSelectedRowKeys([]);
        loadData(initPgCfg, initSearch);
    }

    const loadData = async (page: ISearchPage = initPgCfg, searchValue: ISupplierSearchFields = searchParam) => {
        setLoading(true);
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await supplierService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
        setLoading(false);
    }
   
    //启禁用
    const onEnableChange = async (id: string, enable: number) =>{
        let { retData } = await supplierService.change({id, enable});
        if(retData){
            globalPrompt('message', { text: `${enable ? '禁用' : '启用'}成功`, type: 'success' })
        }
        loadData()
    }

    //导出模版
    const exportTemplate = async () => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
        try {
            let result = await supplierService.exportTemplate();
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch { setLoadingInfo({ loadingVisible: false, txt: "" }) }
    };

    return {
       /***field***/
       searchParam,
       dataSource,
       selectedRowKeys,
       pgCfg,
       loading,
       /***method***/
       setDataSource,
       setSelectedRowKeys,
       resetSearchParam,
       updateSearchParam,
       loadData,
       onEnableChange,
       exportTemplate
    }
});